<template>
  <div>
    <auth-login
      v-if="authState === LOGIN_STATUSES.loginScreen"
      @login-sent="loginSent"
    />
    <auth-code
      v-if="authState === LOGIN_STATUSES.codeScreen"
      :phone="userPhone"
      :is-registered="isRegistered"
      :timer-interval="timerInterval"
      @back-phone="authState = LOGIN_STATUSES.loginScreen"
      @new-user="newUser"
    />
    <auth-user v-if="authState === LOGIN_STATUSES.userScreen" />
  </div>
</template>

<script>
import { CLEAR_PROFILE, SET_PROFILE } from '@/store/actions/userprofile'
import { LOGIN_STATUSES } from './components/const'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters, mapMutations } from 'vuex'
import AuthCode from '@/views/Auth/components/AuthCode'
import AuthLogin from '@/views/Auth/components/AuthLogin'
import AuthUser from '@/views/Auth/components/AuthUser'

const Profile = RepositoryFactory.get('profile')

export default {
  name: 'Auth',
  components: {
    AuthLogin,
    AuthCode,
    AuthUser,
  },
  props: {
    page: {
      type: Number,
      default: LOGIN_STATUSES.loginScreen,
    },
  },
  data() {
    return {
      LOGIN_STATUSES,
      authState: -1,
      userPhone: '',
      isRegistered: false,
      timerInterval: 0,
    }
  },
  computed: {
    ...mapGetters({
      status: 'auth/authStatus',
    }),
  },
  async created() {
    // для регистрации под админским токеном через адресную строку
    if (
      this.$route.query &&
      this.$route.query.token &&
      this.$route.query.token.length
    ) {
      this.clearProfile(null, { root: true })
      this.logout()
      localStorage.setItem('auth-token', this.$route.query.token)
      await this.getUser()
    }
    this.authState = this.page
  },
  methods: {
    ...mapMutations({
      clearProfile: `userProfile/${CLEAR_PROFILE}`,
      setProfile: `userProfile/${SET_PROFILE}`,
      authSuccess: 'auth/AUTH_SUCCESS',
      logout: 'auth/AUTH_LOGOUT',
    }),
    loginSent(phone, isRegistered, timer, code) {
      this.authState = LOGIN_STATUSES.codeScreen
      this.userPhone = phone
      this.isRegistered = isRegistered
      this.timerInterval = timer

      // вывод подсказки с кодом на тестовом сервере
      if (code) {
        this.$message({
          message: 'Код для авторизации - ' + code,
          type: 'success',
        })
      }
    },
    newUser() {
      this.authState = LOGIN_STATUSES.userScreen
    },
    async getUser() {
      const { data } = await Profile.getProfile()

      if (data) {
        const userType = data.user_type

        if (userType === 1) {
          localStorage.setItem('admin-token', this.$route.query.token)
        }
        if (userType === 6) {
          localStorage.setItem('ceo-token', this.$route.query.token)
        }
        this.setProfile({ data, userType })
        this.authSuccess(localStorage.getItem('auth-token'))
        this.$router.push('/home')
      }
    },
  },
}
</script>

<style lang="sass" scoped>
::v-deep .login
  display: flex
  flex-direction: column
  justify-content: space-between
  height: calc(100vh - 9.3rem)
  max-width: 450px
  margin: 0 auto
  padding: 6rem 1.6rem 4rem
  font-family: 'Mulish', sans-serif

  &__title
    width: 30rem
    margin-bottom: 1.2rem
    font-size: 2.8rem
    line-height: 3.6rem
    font-weight: 800
    color: #181818

  &__description
    font-size: 1.6rem
    line-height: 2rem
    color: #747474

  .input__error
    display: flex
    align-items: center

    &-image
      width: 1.6rem
      height: 1.6rem
      margin-right: 0.9rem

      img
        width: 100%
        height: 100%
    &-text
      font-size: 1.2rem
      color: #FF3030
</style>
